export default __webpack_public_path__ + "static/media/G_D_btn___gallery_succ.f8a53e34.svg";